import React from "react";
import s from "./AboutHub.module.scss";
import Header from "../../components/Header/LandingHeader";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../components/WindowDimentions/WindowDimentions";
import { Link } from "react-router-dom";
import PageTitle from "../../components/PageTitle/PageTitle";
import HubStructure from "../../components/HubStructure/HubStructure";

type Props = {};

const AboutHub = (props: Props) => {
  const { width } = useWindowDimensions();
  return (
    <div>
      {width > 600 ? <Header /> : <MobileHeader />}
      <div className={s.content}>
        <PageTitle className={s.h2} eyebrow="About us" title="About “Digital Transit HUB”" />
        <div className={s.text}>
          <div>
            Despite the friendly relations and political will of our countries
            to facilitate trade, a flexible mechanism and innovative tools for
            expedited vehicle crossings at border checkpoints are still lacking.
          </div>
          <div>
            In this regard, the “Digital Transit Hub” was developed at the
            request and according to the technical tasks of the Middle Corridor
            Transit Advisory Committee, with the aim of simplifying trade and
            transit procedures along the Middle Corridor. This project was
            developed within the framework of the international Trans-Caspian
            International Transport Route (TITR) program, which is a key
            initiative. There are also earlier initiatives, such as TRACECA (the
            Europe–Caucasus–Asia Transport Corridor), funded by the European
            Union. Additionally, there are regional cooperation programs such as
            “Digitalization of the Silk Road” and the CAREC (China–Central
            Asia–Europe) program.
          </div>
          <div>
            By creating the “Digital Transit Hub” MARKETPLACE, the members of
            the MCTAC Council are introducing a new tool that enables the
            advance preparation of all necessary documents for customs clearance
            and logistics before a vehicle arrives in its destination country.
            Regional representatives (partners) are established in each region
            (country) to organize the business processes related to providing
            services to customers from other partner countries. These regional
            representatives serve as administrators (with system access rights)
            of the “Digital Transit Hub” in their respective regions based on a
            legal cooperation agreement with MCTAC.
          </div>
          <div>
            The organizational structure for interaction with regional
            representatives is presented below:
          </div>
        </div>
      </div>
      <HubStructure />
      <LandingFooter />
    </div>
  );
};

export default AboutHub;
